import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/authSlice'
import reportsReducer from './reports/reportsSlice'
import usersReducer from './users/usersSlice'
import changesReducer from './changes/changesSlice'
import materialsReducer from './materials/materialSlice'
import questionsReducer from './questions/questionsSlice'
import appConfigReducer from './appConfig/appConfigSlice'

const reducers = {
  auth: authReducer,
  reports: reportsReducer,
  users: usersReducer,
  changes: changesReducer,
  materials: materialsReducer,
  questions: questionsReducer,
  appConfig: appConfigReducer,
}

const rootReducer = combineReducers(reducers)

const resettableRootReducer = (
  state: ReturnType<typeof rootReducer> | undefined,
  action: AnyAction,
) => {
  if (action.type === 'auth/logOut') {
    state = undefined
    return rootReducer(undefined, action)
  }

  return rootReducer(state, action)
}

export const store = configureStore({
  reducer: resettableRootReducer,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
